import React from "react";
import StatusToolbar from "./status_toolbar/StatusToolbar";
import StatusRejectedToolbar from "./status_rejected_toolbar/Status_Rejected_Toolbar";
import { StatusCardView } from "~/app/index";
import {
  Header,
  SideNavbar,
  TokenCheck
} from "~/app/index";
class ClaimStatusWrapper extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      showBoardingModal: false,
    }

  }

  render() {

    // if (!this.props.history.location.state) {
    //   if(localStorage.getItem('authToken') === null){
    //     return (<Redirect to="/login" />);
    //   }
    // }

    return (
      <div>
        <TokenCheck/>
        <Header />
        <SideNavbar />
        <div className="body-content">
          <div className="page-title">Batch Status</div>
          <div className="page-subtitle">Subtitle</div>
          <StatusRejectedToolbar/>
          <div className="status-content">
            {/* <SetupOnBoarding 
              show={this.state.showBoardingModal} 
              onHideShowBoarding={this.handlehideShowBoarding}
              formData={this.formDatas} 
            /> */}
            <StatusToolbar />
            <StatusCardView />
          </div>
        </div>
      </div>
    );
  }
}
export default ClaimStatusWrapper;






// WEBPACK FOOTER //
// ./src/app/batch_status/Claim_Status_Wrapper.js